'use client';

import type { ReactNode } from 'react';

import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { SimpleLayout } from 'src/layouts/simple';

import { varBounce, MotionContainer } from 'src/components/animate';

// ----------------------------------------------------------------------

/**
 * 오류 화면 셋(403 · 500 · 404)의 한 틀 — 제목 · 설명 · 그림이 차례로 튀어 오르고 아래에
 * 홈(`/`)으로 가는 버튼이 선다. 문구와 그림은 화면이 넘긴다.
 *
 * ⚠️ **화면 글은 한국어다** — 사고가 난 순간에 남의 말이 뜨면 「우리 서비스가 아닌 화면」으로 읽힌다
 * (전역 오류 경계도 한국어다).
 */
export function ErrorPageLayout({
  title,
  description,
  illustration,
  actionLabel,
}: {
  title: string;
  description: ReactNode;
  illustration: ReactNode;
  actionLabel: string;
}) {
  return (
    <SimpleLayout
      slotProps={{
        content: { compact: true },
      }}
    >
      <Container component={MotionContainer}>
        <m.div variants={varBounce('in')}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            {title}
          </Typography>
        </m.div>

        <m.div variants={varBounce('in')}>
          <Typography sx={{ color: 'text.secondary' }}>
            {description}
          </Typography>
        </m.div>

        <m.div variants={varBounce('in')}>
          {illustration}
        </m.div>

        <Button component={RouterLink} href="/" size="large" variant="contained">
          {actionLabel}
        </Button>
      </Container>
    </SimpleLayout>
  );
}
